var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-plan-list"},[_c('RoundingForm',{attrs:{"label":"Rounding To","noDescription":"","read-only":""},model:{value:(_vm.rate.round_to),callback:function ($$v) {_vm.$set(_vm.rate, "round_to", $$v)},expression:"rate.round_to"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }